import { Button, Card, Form, Input, InputNumber, Segmented, Select, Space } from 'antd';
import { useForm } from '@refinedev/antd';
import { IExperienceEvent } from '../../../interfaces/experience';

const fields = [
  'id',
  'name',
  'reservationType',
  'eventType',
  'status',
  'publishStatus',
  'ageLimit',
  'childReservationMax',
];

export const ConfigForm = () => {
  const { formProps, form, queryResult, mutationResult } = useForm<IExperienceEvent>({
    resource: 'experienceEvents',
    action: 'edit',
    redirect: false,
    meta: {
      fields,
    },
    mutationMeta: {
      fields: [{ experienceEvent: fields }],
    },
  });

  const isLoading = queryResult?.isLoading || mutationResult?.isLoading;

  return (
    <Form data-test-id="ConfigForm" layout="vertical" {...formProps}>
      <Card
        title="設定"
        extra={
          <Space align="end">
            <Button type="primary" htmlType="submit" loading={isLoading}>
              保存
            </Button>
            <Button onClick={() => form.resetFields()}>リセット</Button>
          </Space>
        }
      >
        <Form.Item label="予約タイプ" name="reservationType">
          <Select
            options={[
              { label: '予約なし', value: 'no_reservation' },
              { label: '予約(日付/時間)', value: 'date_time_reservation' },
              { label: '予約(日付/時間/プラン)', value: 'date_time_plan_reservation' },
            ]}
          />
        </Form.Item>
        <Form.Item label="イベントタイプ" name="eventType">
          <Select
            options={[
              { label: 'LAB', value: 'lab' },
              { label: 'その他', value: 'other' },
            ]}
          />
        </Form.Item>
        <Form.Item label="年齢制限" name="ageLimit">
          <Select
            options={[
              { label: '3歳以上', value: 'over3' },
              { label: '未就学児', value: 'preschooler' },
              { label: '小学生', value: 'elementary_school' },
            ]}
          />
        </Form.Item>
        <Form.Item label="同時予約人数" name="childReservationMax">
          <InputNumber suffix="人" />
        </Form.Item>
      </Card>
    </Form>
  );
};
